import { getTemplate } from "../template-helper";
import { waiter } from "../../util/utils";

const COMPONENT_NAME = "z-binary";

const TEMPLATE_ID = "component-" + COMPONENT_NAME + "-template";
const TEMPLATE_URL = "/static/libs/components/" + COMPONENT_NAME + ".html";

export default function register() {
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template) => {

        class BinaryComponent extends HTMLElement {
            constructor() {
                super();
                this.chosenFile = null;
                this.currentFile = null;
                this.originalFile = null;
                this.isAlreadyBackupOriginalFile = false;
            }

            connectedCallback() {
                this.chosenFile = null;
                this.currentFile = null;
                this.init();
            }


            init() {
                this.divView = this.querySelector(".z-binary-view");
                if(!this.divView){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                }

                this.inputHidden = this.querySelector("input.z-binary-hidden");
                this.buttonDownload = this.querySelector(".z-binary-btn-download");
                this.buttonDownload.addEventListener("click", () => {
                    if (this.chosenFile) {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(this.chosenFile);
                        link.download = this.chosenFile.name;
                        link.click();
                        return;
                    } else if (this.currentFile) {
                        let url = "/api/binary/";
                        if (this.hasAttribute("z-app")) {
                            url = "/api/" + this.getAttribute("z-app") + "/binary/";
                        }
                        url += this.currentFile._id;

                        waiter(
                            fetch(url).then((response) => {
                                if (response.status < 200 || response.status > 299) {
                                    return response.text().then((text) => {
                                        let msg = text;
                                        try {
                                            msg = JSON.parse(text);
                                        } catch (e) {
                                            //ignore parse error, it is not a JSON object
                                        }
                                        if (!msg) {
                                            msg = "error";
                                        }
                                        throw msg;
                                    });
                                }
                                return response.arrayBuffer();

                            }).then(buffer => {
                                var blob = new Blob([buffer], { type: this.currentFile.mimetype });
                                var link = document.createElement('a');
                                link.href = window.URL.createObjectURL(blob);
                                link.download = this.currentFile.filename;
                                link.click();
                            })
                        );
                    }
                });

                this.filenameLabel = this.querySelector(".z-binary-filename");

                this.input = this.querySelector("input.form-control-file");
                this.input.addEventListener("change", () => {
                    this.chosenFile = this.input.files[0];
                    if(this.chosenFile){
                        this.chosenFile.url = URL.createObjectURL(this.chosenFile);
                        this.inputHidden.value="file";
                    }else{
                        this.inputHidden.value="";
                    }
                    this.renderWidget();
                });

                this.buttonOpenFile = this.querySelector(".z-binary-btn-open");
                this.buttonOpenFile.addEventListener("click", () => {
                    this.input.click();
                });

                this.buttonClear = this.querySelector(".z-binary-btn-clear");
                this.buttonClear.addEventListener("click", () => {
                    this.input.value = null;
                    this.chosenFile = null;
                    this.currentFile = null;
                    this.inputHidden.value = "" ;
                    this.dispatchEvent(new Event("change", { bubbles: true }));
                    this.renderWidget();
                });

                this.buttonUndo = this.querySelector(".z-binary-btn-undo");
                this.buttonUndo.addEventListener("click", () => {
                    this.chosenFile = null;
                    this.currentFile = this.originalFile;
                    if(this.currentFile){
                        this.inputHidden.value = "file" ;
                    }else{
                        this.inputHidden.value = "" ;
                    }
                    this.dispatchEvent(new Event("change", { bubbles: true }));
                    this.renderWidget();
                });

                this.divView = this.querySelector(".z-binary-view");
                this.divInput = this.querySelector(".z-binary-input");

                this.renderWidget();
            }

            renderWidget() {
                if (!this.divView) { return; }

                if (this.chosenFile) {
                    this.divView.classList.remove("d-none");
                    this.filenameLabel.setAttribute("placeholder", this.chosenFile.name);
                } else if (this.currentFile) {
                    this.filenameLabel.setAttribute("placeholder", this.currentFile.filename||this.currentFile.name);
                    this.divView.classList.remove("d-none");
                } else {
                    this.filenameLabel.setAttribute("placeholder", "-");
                    this.divView.classList.add("d-none");
                }

                if (this.chosenFile === null && this.originalFile === this.currentFile) {
                    this.buttonUndo.setAttribute("disabled", "disabled");
                } else {
                    this.buttonUndo.removeAttribute("disabled");
                }

                if (this.chosenFile || this.currentFile) {
                    this.buttonClear.removeAttribute("disabled", "true");
                } else {
                    this.buttonClear.setAttribute("disabled", "disabled");
                }

                if (this.hasAttribute("readonly")) {
                    this.divInput.classList.add("d-none");
                } else {
                    this.divInput.classList.remove("d-none");
                }
                if (this.required) {
                    this.inputHidden.required = true;
                }else{
                    this.inputHidden.required = false;
                }
                if(this.customValidity){
                    this.inputHidden.setCustomValidity(this.customValidity) ;
                }
                if(this.hasAttribute('accept')) {
                    this.input.setAttribute('accept', this.getAttribute('accept')) ;
                } else {
                    this.input.removeAttribute('accept') ;
                }
                this.inputHidden.value=this.value?"file":"";
            }

            get required() {
                return this.hasAttribute("required");
            }

            set required(required) {
                if(required){
                    this.setAttribute('required', required);
                }else{
                    this.removeAttribute('required');
                }
            }

            get value() {
                if (this.chosenFile) {
                    return this.chosenFile;
                }
                return this.currentFile;
            }

            setCustomValidity(msg){
                this.customValidity = msg ;
                if(this.inputHidden){
                    this.inputHidden.setCustomValidity(msg) ;
                }
            }

            set value(value) {
                if (this.isAlreadyBackupOriginalFile === false) {
                    this.originalFile = value? value : null;
                    this.isAlreadyBackupOriginalFile = true;
                }
                this.currentFile = value? value : null;
                if(!value){
                    this.chosenFile = null ;
                }else if(this.currentFile.constructor === File){
                    this.chosenFile = this.currentFile ;
                }else if(this.currentFile._id){
                    this.chosenFile = null ;
                }

                if(this.currentFile){
                    this.inputHidden.value="file";
                }else{
                    this.inputHidden.value="";
                }
                if(value && !value.url){
                    try{
                        value.url = URL.createObjectURL(value);
                    }catch(err){
                        //value is not a file, ignore
                    }
                }
                this.renderWidget();
            }

            static get observedAttributes() {
                return ['readonly', "required"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'required':
                        this.renderWidget();
                        break;
                    case 'readonly':
                        this.renderWidget();
                        break;
                    case 'accept':
                        this.renderWidget();
                        break;
                }
            }
        }
        customElements.define(COMPONENT_NAME, BinaryComponent);
    }).catch((err) => {
        throw err;
    });
}
